import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../LayoutContainers/DashboardLayout';
import { PermissionUsersList } from 'components/Permissions/PermissionUsersList';
import { PermissionDevicesList } from 'components/Permissions/PermissionDevicesList';

const ManagePermissionsLayout = ({ objectName, children }) => {
  return (
    <DashboardLayout>
      <DashboardNavbar objectName={objectName} />
      <Typography fontSize="11px" sx={{ paddingLeft: { xs: 0, sm: '12px' }, marginTop: { xs: '-15px', sm: '-5px' }, textAlign: { xs: 'center', sm: 'left' } }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox>
        <Grid container>
          {children}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

ManagePermissionsLayout.propTypes = {
  objectName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const ManagePermissionUsersPage = () => (
  <ManagePermissionsLayout objectName="User permissions">
    <Grid item xs={12}>
      <PermissionUsersList />
    </Grid>
  </ManagePermissionsLayout>
);

export const ManagePermissionDevicesPage = () => (
  <ManagePermissionsLayout objectName="Device permissions">
    <Grid item xs={12}>
      <PermissionDevicesList />
    </Grid>
  </ManagePermissionsLayout>
);
